module.exports = __webpack_public_path__ + "static/media/example_logo.cdb88006.png";